<template>
    <toolbar :id="toolbarId" side="left">
        <toolbar-insert :screen="screen" :toolbar="toolbarId" />
    </toolbar>
</template>

<script>
import Toolbar from '@/components/utilities/toolbar';
import ToolbarInsert from '@/components/shared/toolbars/toolbar-insert';

export default {
    name: 'toolbar-component',
    components: { Toolbar, ToolbarInsert },

    props: {
        screen: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            toolbarId: 'component',
        };
    },
};
</script>
